import _ from "lodash";
import { flow } from "mobx";
import { QueryClient } from "react-query";
import { UploadDocumentResponse } from "../../../../api/documents/uploadDocument";
import { createFormData } from "../../../../api/FormDataFactory";
import { scrollIntoView } from "../../../../WSUtils/scrollIntoView";
import { invalidateQueries } from "../../../../WSUtils/useLatestQuery";
import { UserInfo } from "../../../../WSUtils/UserInfo";
import { CVEditContextStore } from "../../CVEditContext";
import {
  CVEditDocumentEditorStore,
  CVEDocumentWords,
} from "./CVEditDocumentEditor";

export interface SaveCurrentlyEditingDocumentAndCloseEditorParams {
  userInfo: UserInfo;
  cvEditContext: CVEditContextStore;
  queryClient: QueryClient;
  file: File;
  editorStore: CVEditDocumentEditorStore;
}

export const saveCurrentlyEditingDocumentAndCloseEditor = flow(function* ({
  userInfo,
  cvEditContext,
  queryClient,
  file,
  editorStore,
}: SaveCurrentlyEditingDocumentAndCloseEditorParams) {
  editorStore.hasAttemptedToClose = true;

  if (editorStore.validationErrors.length > 0) return;

  const documentsAPI = userInfo.fullAPI.documentsAPI;

  const carryFormData = new FormData();
  carryFormData.append("fileData", file);

  const split = file.name.split(".");
  const fileExtension = split.length > 1 ? _.last(split) : "";

  const value = editorStore.documentNameField.store.value;

  let filename = value.filename.trim();
  if (value.type === CVEDocumentWords.CV) {
    filename = CVEDocumentWords.CV;
  } else if (value.type === CVEDocumentWords.copyOfId) {
    filename = CVEDocumentWords.copyOfId;
  } else if (value.type === CVEDocumentWords.signedWorkAgreement) {
    filename = CVEDocumentWords.signedWorkAgreement;
  }

  if (fileExtension) {
    filename += `.${fileExtension}`;
  }

  let departmentId = userInfo.currentFirmCandidate.id_avdelinger;

  if (cvEditContext.dataFromServer.job) {
    departmentId = cvEditContext.dataFromServer.job.job.idDepartment;
  }

  const formData = createFormData(
    {
      departmentId,
      filename,
      documentType: 0, // not in use on backend
    },
    null,
    carryFormData
  );

  const headers = { "Content-Type": null };

  const result: UploadDocumentResponse = yield documentsAPI.uploadDocument({
    showSentryDialogOnError: true,
    userInfo,
    headers,
    formData,
  });

  yield invalidateQueries(queryClient, ["documentsAPI.getDocuments"]);

  if (result.ok) {
    editorStore.closeEditor();

    scrollIntoView(document.querySelector(".cve-container"));
  }

  return result;
});
